function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#90CAF9",
  points: "40,45 8,45 8,3 30,3 40,13"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#E1F5FE",
  points: "38.5,14 29,14 29,4.5"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#1976D2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 21,
  width: 17,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 25,
  width: 13,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 29,
  width: 17,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 33,
  width: 13,
  height: 2
}));

function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.784,
    height: 40.581,
    viewBox: "0 0 45.784 40.581",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc_icon.793a86f8.svg";
export { ForwardRef as ReactComponent };